export enum FilterType {
  NAME = 'NAME',
  ADDRESS = 'ADDRESS',
  EMAIL = 'EMAIL',
}
